export default {"src":"/_next/static/image/public/images/ic_rx_arrow.386f139036dad8b9d36ae2683426c33a.svg","height":20,"width":20};